module.exports = __webpack_public_path__ + "media/images/flags/de-637ec89ab052cad77631c380a72dae96.svg";